import { useHistory, useLocation } from 'react-router-dom'
import useGroupedBasket from 'hooks/useGroupedBasket'
import React, { useEffect } from 'react'
import Summary from './Summary'
import List from './List'
import './style.scss'

interface BasketPopupProps {
  isDesktop?: boolean
}

interface Popup {
  popup?: {
    type?: 'basket'
  }
}

const BasketPopup: React.FC<BasketPopupProps> = ({ isDesktop }) => {
  const list = useGroupedBasket()
  const { state } = useLocation<Popup>()
  const isBasketExpanded = state?.popup?.type === 'basket'

  const { goBack } = useHistory()

  useEffect(() => {
    const escDetect = (e: KeyboardEvent) => {
      if (e.code === 'Escape') {
        goBack()
      }
    }

    document.addEventListener('keydown', escDetect, false)
    return () => {
      document.removeEventListener('keydown', escDetect, false)
    }
  }, [goBack])

  return (
    <div
      className={`basketPopup__bg${isBasketExpanded ? '' : ' --close'} ${isDesktop ? '--desktop' : ''}`}
      onClick={isDesktop ? goBack : undefined}>
      <div
        className='basketPopup'
        onClick={e => {
          e.stopPropagation()
        }}>
        <List list={list} />
        <Summary list={list} />
      </div>
    </div>
  )
}

export default BasketPopup